import { Injectable } from "@angular/core";
import { BaseEntitiesResponse, HistoryChangesSet } from "@base/entities/BaseEntities";
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { Observable } from "rxjs";
import { APIGatewayService } from "../gateway/APIGateway.service";



@Injectable()
export class HistoryEndpoint extends BaseEndpointCRUD<HistoryChangesSet> {
    //Constructor
    constructor(api: APIGatewayService) {
        super("History", api);
    }
}
